import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import formtemplate from './modules/formtemplate'
import userform from './modules/userform'
import users from './modules/users'
import notifications from './modules/notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    formtemplate,
    userform,
    users,
    notifications
  }
})
